import { UseCatalogLiveShopParams, UseCatalogLiveShopResult } from '../catalogLiveShop.types';
import { getYoutubeVideoId, hasCatalogLiveShopVideo } from '../catalogLiveShop.utils';

const useCatalogLiveShop = ({
  liveLink,
  isOfflineMode,
}: UseCatalogLiveShopParams): UseCatalogLiveShopResult => {
  const videoId = liveLink ? getYoutubeVideoId(liveLink) : null;
  const isAvailable = !isOfflineMode && hasCatalogLiveShopVideo(liveLink);
  const embedDomain = window.location.hostname;

  return { isAvailable, videoId, embedDomain };
};

export default useCatalogLiveShop;
